var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIrSymbolPaths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "40px",
    viewBox: "0 0 211.66 169.38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-272.74 -333.46)",
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277.56 377.7a157.14 157.14 0 0 1 202.02 0",
    color: "#000000",
    colorRendering: "auto",
    fill: "none",
    imageRendering: "auto",
    "solid-color": "#000000",
    stroke: "#f00",
    strokeWidth: 15,
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.93 399.59a128.57 128.57 0 0 1 165.29 0",
    color: "#000000",
    colorRendering: "auto",
    fill: "none",
    imageRendering: "auto",
    "solid-color": "#000000",
    stroke: "#f00",
    strokeWidth: 15,
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.64 423.07a97.908 97.908 0 0 1 125.87 0",
    color: "#000000",
    colorRendering: "auto",
    fill: "none",
    imageRendering: "auto",
    "solid-color": "#000000",
    stroke: "#f00",
    strokeWidth: 15,
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    color: "#000000",
    colorRendering: "auto",
    fill: "#f00",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m337.97 502.84v-64.248h13.623v64.248h-13.623z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m381.47 467.11h4.3945q6.46 0 9.5361-2.1533 3.0762-2.1533 3.0762-6.7676 0-4.5703-3.1641-6.5039-3.1201-1.9336-9.7119-1.9336h-4.1309v17.358zm0 11.074v24.653h-13.623v-64.248h18.721q13.096 0 19.38 4.79 6.2842 4.7461 6.2842 14.458 0 5.669-3.1201 10.107-3.1201 4.3945-8.833 6.8994 14.502 21.665 18.896 27.993h-15.117l-15.337-24.653h-7.251z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrSymbolPaths);
export default __webpack_public_path__ + "static/media/IR_symbol_paths.b3a774f812b034049418ecea2c417e91.svg";
export { ForwardRef as ReactComponent };